import { ReactNode } from 'react';
import { cn } from '@prenuvo/halo-foundation';

interface SidePanelOverlayProps {
  children: ReactNode;
  isOpen: boolean;
}

export function SidePanelOverlay({ children, isOpen }: SidePanelOverlayProps) {
  return (
    <div
      className={cn('z-40 fixed top-16 right-0 h-full w-1/2', {
        invisible: !isOpen,
      })}
    >
      {children}
    </div>
  );
}
